<template>
  <div>
    <titulo-modulo titulo="Minhas indicações" />
    <v-row dense>
      <v-col>
        <v-dialog v-model="dialog"  scrollable max-width="850">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              rounded
              height="30"
              outlined
              v-on="on"
              v-bind="attrs"
              color="info"
              ><v-icon size="17" class="mr-2">mdi-help-circle-outline</v-icon
              >Orientações</v-btn
            >
          </template>
          <orientacoes-indicacao-pcd>
            <v-spacer></v-spacer>
            <v-btn text rounded @click="dialog = false">Fechar</v-btn>
          </orientacoes-indicacao-pcd>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <nova-indicacao-pcd />
      </v-col>
    </v-row>
    <v-progress-linear class="mt-2" v-if="loading"></v-progress-linear>
    <template v-else>
      <v-tabs
        class="mt-3 rounded-md"
        grow
        active-class="font-weight-bold"
        background-color="green lighten-5"
        v-model="tab"
        slider-size="3"
      >
        <v-tab>Pendentes</v-tab>
        <v-tab>Finalizadas</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <lista-indicacoes-pcd
            :indicacoes="indicacoes.filter((ind) => !ind.status_final)"
          />
        </v-tab-item>
        <v-tab-item>
          <lista-indicacoes-pcd
            :indicacoes="indicacoes.filter((ind) => ind.status_final)"
          />
        </v-tab-item>
      </v-tabs-items>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TituloModulo from "../../components/TituloModulo.vue";
import ListaIndicacoesPcd from "./components/ListaIndicacoesPcd.vue";
import NovaIndicacaoPcd from "./buttons/BtnNovaIndicacaoPcd.vue";
import OrientacoesIndicacaoPcd from "./components/OrientacoesIndicacaoPcd.vue";
export default {
  components: {
    TituloModulo,
    ListaIndicacoesPcd,
    OrientacoesIndicacaoPcd,
    NovaIndicacaoPcd,
  },
  computed: mapState("pcd", ["indicacoes"]),
  data: () => ({
    tab: 0,
    dialog: false,
    loading: true,
  }),
  methods: {
    ...mapActions("pcd", ["getMinhasIndicacoes"]),
  },
  async created() {
    this.loading = true;
    await this.getMinhasIndicacoes();
    this.loading = false;
  },
};
</script>

<style>
</style>